import dateFormat from "./DateFormat.service";
import { tryDate, tryNumber } from "./formatExcel.service";

export const saveAsExcelFile = (buffer, fileName) => {
    /*Función encargada de guardar y descargar el archivo Excel del reporte*/
    import('file-saver').then(FileSaver => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.default.saveAs(data, fileName + '_' + dateFormat(new Date()) + EXCEL_EXTENSION);
    });
}

export function excelReport(reporte, nombre) {
    /*Función encargada de construir el archivo Excel del reporte*/
    const DATE_NF = "dd/mm/yyyy";
    import("xlsx").then(xlsx => {
        const workbook = xlsx.utils.book_new();
        reporte["SHEETS"].forEach(sheet => {
            let sheetLines = []
            sheet["DETAIL"].forEach((line, index) => {
                let fila = line.LINE.split("|")
                if (index > 0) {
                    for (let c = 0; c < fila.length; ++c) {
                        const asDate = tryDate(fila[c]);
                        if (asDate) { fila[c] = asDate; continue; }

                        const asNum = tryNumber(fila[c]);
                        if (asNum !== null) { fila[c] = asNum; }
                    }
                }
                sheetLines.push(fila)
            })
            const worksheet = xlsx.utils.aoa_to_sheet(sheetLines, {
                dense: true,
                cellDates: true
            })
            const data = worksheet;
            for (let R = 1; R < data.length; ++R) {
                const row = data[R];
                if (!row) continue;
                for (let C = 0; C < row.length; ++C) {
                    const cell = row[C];
                    if (!cell) continue;
                    console.log(cell)
                    if (cell.t === "d") {
                        cell.z = DATE_NF;
                    }
                    else if (cell.t === "n") {
                        if (Number.isInteger(cell.v)) {
                            cell.z = "0";              // entero: sin decimales
                        } else {
                            const decLen = ((cell.v + "")
                                .split(".")[1] || "")       // "4232"
                                .replace(/0+$/, "")         // quita ceros finales
                                .length;                    // => 4

                            cell.z = "0." + "0".repeat(decLen); // "0.0000"
                        }
                    }
                    else {
                        if (cell.v === "") {
                            delete row[C];
                        }
                    }
                }
            }
            xlsx.utils.book_append_sheet(workbook, worksheet, sheet.NAME)
        })
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, nombre)
    })
}